<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <pr-input-select-template
      formControlName="scpiSelectionType"
      [options]="options"
    >
      <ng-template #optionTemplate let-option let-id="index">
        <div>
          <div>
            <residence-box
              [suffix]="option.suffix"
              [title]="option.label"
              [svg]="option.svg"
            ></residence-box>
          </div>
        </div>
      </ng-template>
    </pr-input-select-template>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
